import React from 'react';
import GaugeComponent from 'react-gauge-component';

function GaugeChartComponent({ hepaValue }) {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <GaugeComponent
        value={hepaValue}  // Zakładamy, że wartość w zakresie 0-100
        type="radial"
        labels={{
          tickLabels: {
            type: "inner",
            ticks: [
              { value: 10 },
              { value: 25 },
              { value: 50 },
              { value: 75 }
            ]
          }
        }}
        maxValue={100}
        arc={{
          colorArray: ['#5BE12C', '#EA4228'],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3
        }}
        pointer={{
          animationDuration: 5000
        }}
      />
    </div>
  );
}

export default GaugeChartComponent;
